type Translate = (key: string, options?: Record<string, unknown>) => string;

export const getSubmitButtonText = (
   isSendPalletsDataFileUploaded: boolean,
   isSendPalletsDataFileVerified: boolean,
   isModalEditMode: boolean,
   t: Translate,
) => {
   if (isSendPalletsDataFileUploaded && !isSendPalletsDataFileVerified) {
      return t('sendPalletsModal.utils.verifyAddresses');
   }
   return isModalEditMode
      ? t('sendPalletsModal.utils.saveChanges')
      : t('sendPallets.sendPalletsBtn');
};
